// https://github.com/euvl/vue-notification/blob/master/README.md
import Notifications from 'vue-notification';
import Vue from 'vue';
Vue.use(Notifications);